var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75,9.5c0,0.31369 -0.23254,0.56897 -0.5188,0.56897h-7.68933v0v8.07385c0,0.30054 -0.24316,0.54468 -0.54187,0.54468c-0.29871,0 -0.54187,-0.24414 -0.54187,-0.54468v-8.07385v0h-7.68933c-0.28625,0 -0.5188,-0.25528 -0.5188,-0.56897c0,-0.31369 0.23254,-0.56897 0.5188,-0.56897h7.68933v0v-8.07385c0,-0.30057 0.24316,-0.54468 0.54187,-0.54468c0.29871,0 0.54187,0.24411 0.54187,0.54468v8.07385v0h7.68933c0.28625,0 0.5188,0.25528 0.5188,0.56897"
  })));
};
export default SvgPlus;